import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import AnswerRenderer from '../AnswerRenderer';
import './AnswerSection.scss';
import { getRequest } from '../../../requestUtils';
var AnswerSection = /*#__PURE__*/function (_Component) {
  function AnswerSection(props) {
    var _this;
    _classCallCheck(this, AnswerSection);
    _this = _callSuper(this, AnswerSection, [props]);
    _this.state = {
      answers: null,
      showReadMore: false,
      isReadingMore: props.isReadingMore
    };
    _this.getAndSetAnswers = _this.getAndSetAnswers.bind(_this);
    _this.getAnswers = _this.getAnswers.bind(_this);
    _this.updateSingleAnswer = _this.updateSingleAnswer.bind(_this);
    _this.readMore = _this.readMore.bind(_this);
    return _this;
  }
  _inherits(AnswerSection, _Component);
  return _createClass(AnswerSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getAndSetAnswers();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.fullView !== prevProps.fullView) {
        this.getAndSetAnswers();
      }
    }
  }, {
    key: "getAndSetAnswers",
    value: function getAndSetAnswers() {
      var _this2 = this;
      this.getAnswers().then(function (response) {
        var answers = response.data;
        _this2.setState({
          answers: answers
        });
        var isOneSection = answers && answers.length === 1;
        var isTagFilled = answers && answers.reduce(function (filledTags, answer) {
          return answer.answer && answer.answer.length !== 0 ? filledTags + 1 : filledTags;
        }, 0);
        _this2.setState({
          showReadMore: isTagFilled > 5 || isOneSection && (answers[0].question_type === 'group_parent' && answers[0].question_key !== 'Language' || answers[0].question_type === 'list' || answers[0].question_type === 'past_roles') && answers[0].answer && answers[0].answer.length > 2
        });
      });
    }
  }, {
    key: "getAnswers",
    value: function getAnswers() {
      var _this$props = this.props,
        fullView = _this$props.fullView,
        questionCategoryId = _this$props.questionCategoryId,
        questionableId = _this$props.questionableId,
        questionableType = _this$props.questionableType,
        questionnaireName = _this$props.questionnaireName;
      return getRequest('/question_answers/answers', {
        questionnaire_name: questionnaireName,
        question_category_id: questionCategoryId,
        questionable_id: questionableId,
        questionable_type: questionableType,
        full_view: fullView
      });
    }
  }, {
    key: "updateSingleAnswer",
    value: function updateSingleAnswer(answer) {
      var _this3 = this;
      var _this$props2 = this.props,
        questionableId = _this$props2.questionableId,
        questionableType = _this$props2.questionableType,
        updateCompletionPercentage = _this$props2.updateCompletionPercentage;
      var answers = this.state.answers;
      getRequest("/question_answers/".concat(answer.id), {
        questionable_id: questionableId,
        questionable_type: questionableType
      }).then(function (response) {
        updateCompletionPercentage();
        var newAnswer = response.data;
        var curAnswerIndex = answers.findIndex(function (a) {
          return a.id === newAnswer.id;
        });
        if (curAnswerIndex !== -1) {
          var newAnswers = update(answers, _defineProperty({}, curAnswerIndex, {
            $set: newAnswer
          }));
          _this3.setState({
            answers: newAnswers
          });
        }
      });
    }
  }, {
    key: "readMore",
    value: function readMore() {
      this.setState({
        isReadingMore: !this.state.isReadingMore
      });
    }
  }, {
    key: "isReadingMoreStatus",
    value: function isReadingMoreStatus() {
      var fullView = this.props.fullView;
      var _this$state = this.state,
        answers = _this$state.answers,
        isReadingMore = _this$state.isReadingMore,
        showReadMore = _this$state.showReadMore;
      if (answers[0].question_type === 'past_roles') return isReadingMore;
      return fullView || (showReadMore ? isReadingMore : true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props3 = this.props,
        customClass = _this$props3.customClass,
        title = _this$props3.title,
        fullView = _this$props3.fullView,
        questionCategoryId = _this$props3.questionCategoryId,
        questionableId = _this$props3.questionableId,
        questionableType = _this$props3.questionableType,
        csrfToken = _this$props3.csrfToken,
        editMode = _this$props3.editMode,
        questionnaireName = _this$props3.questionnaireName,
        hideFooterButton = _this$props3.hideFooterButton,
        suggestedTags = _this$props3.suggestedTags,
        updateSuggestedTags = _this$props3.updateSuggestedTags,
        showSuggestionModal = _this$props3.showSuggestionModal,
        needsAttention = _this$props3.needsAttention,
        onAttentionClick = _this$props3.onAttentionClick;
      var _this$state2 = this.state,
        answers = _this$state2.answers,
        showReadMore = _this$state2.showReadMore,
        isReadingMore = _this$state2.isReadingMore;
      if (answers && answers.length === 0) {
        return null;
      }
      if (answers && answers.length > 0) {
        var answs = answers.filter(function (a) {
          return fullView || a["public"] === true;
        });
        var truncateAnswers = !fullView && showReadMore && !isReadingMore;
        if (title === 'Technical Experience' && !fullView && answers.reduce(function (filledTags, answer) {
          return answer.answer.length !== 0 ? filledTags + 1 : filledTags;
        }, 0) < 1) {
          return null;
        }
        if (!(title === 'Technical Experience') && (answers[0].answer === null || answers[0].answer.length === 0 || answers[0].answer === 'Not Applicable') && !fullView) {
          return null;
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "answer-section ".concat(customClass, " ").concat(title)
        }, fullView && needsAttention && /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "attention-badge",
          "aria-label": "".concat(title || 'This section', " needs attention"),
          onClick: function onClick() {
            return onAttentionClick(questionCategoryId);
          }
        }), answers.length > 1 && /*#__PURE__*/React.createElement("h2", {
          className: "section-title ".concat(title && 'mb-4')
        }, title), /*#__PURE__*/React.createElement("div", {
          className: "profile-flex flex-children-50"
        }, answs.map(function (answer) {
          if (fullView || answer.answer !== 'Not Applicable') {
            return /*#__PURE__*/React.createElement(AnswerRenderer, {
              questionableId: questionableId,
              questionableType: questionableType,
              fullView: fullView,
              key: answer.id,
              answer: answer,
              childrenQuestionIds: answer.children_questions ? answer.children_questions.map(function (q) {
                return q.qq_id;
              }) : [],
              editMode: editMode,
              questionnaireName: fullView ? questionnaireName : '',
              suggestedTags: suggestedTags[answer.association_model],
              updateSuggestedTags: updateSuggestedTags,
              csrfToken: csrfToken,
              showSuggestionModal: showSuggestionModal,
              editable: fullView,
              isReadingMore: _this4.isReadingMoreStatus(),
              readingMoreThreshhold: answers[0].question_type === 'past_roles' ? 5 : 2,
              closeModalCallback: _this4.updateSingleAnswer,
              hideFooterButton: hideFooterButton,
              paginated: answer.paginated_modal,
              truncateAnswers: truncateAnswers
            });
          }
          return null;
        }), (answers[0].question_type === 'past_roles' || !fullView && showReadMore) && /*#__PURE__*/React.createElement("div", {
          className: "align mt-3"
        }, /*#__PURE__*/React.createElement("a", {
          className: "body-text-2",
          tabIndex: 0,
          role: "link",
          onClick: this.readMore
        }, isReadingMore ? 'View less' : 'View all', ' ', title ? title.toLowerCase() : answs[0].question_key.toLowerCase()))));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "answer-section ".concat(customClass)
      }, /*#__PURE__*/React.createElement("h2", {
        className: "section-title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "profile-flex flex-children-50"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "Loading...")));
    }
  }]);
}(Component);
AnswerSection.propTypes = {
  questionCategoryId: PropTypes.number.isRequired,
  title: PropTypes.string,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  fullView: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  questionnaireName: PropTypes.string.isRequired,
  hideFooterButton: PropTypes.bool,
  updateCompletionPercentage: PropTypes.func,
  suggestedTags: PropTypes.shape({}),
  updateSuggestedTags: PropTypes.func,
  showSuggestionModal: PropTypes.string,
  isReadingMore: PropTypes.bool,
  needsAttention: PropTypes.bool,
  onAttentionClick: PropTypes.func
};
AnswerSection.defaultProps = {
  title: '',
  customClass: '',
  fullView: true,
  editMode: false,
  hideFooterButton: false,
  updateCompletionPercentage: function updateCompletionPercentage() {},
  suggestedTags: {},
  updateSuggestedTags: function updateSuggestedTags() {},
  showSuggestionModal: '',
  isReadingMore: false,
  needsAttention: false,
  onAttentionClick: function onAttentionClick() {}
};
export default AnswerSection;